import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'raw' });
export function setIdentityApiBaseUrl(url) {
    api.setBaseUrl(url);
}
/** Identity-resolution log for a contact, newest-first. */
export async function getContactIdentityResolutions(contactId) {
    return api.get(`/api/contacts/${encodeURIComponent(contactId)}/identity-resolutions`);
}
/** Identity-resolution log for a conversation, newest-first. */
export async function getConversationIdentityResolutions(conversationId) {
    return api.get(`/api/conversations/${encodeURIComponent(conversationId)}/identity-resolutions`);
}
/**
 * Ephemeral identity probe: POST an email, get what the upstream WIT identity
 * API returns. Nothing is persisted server-side. Always 200 — outcomes
 * (not configured / found / not found / error) are encoded in the body.
 */
export async function testIdentity(email) {
    return api.post('/api/identity/test', { email });
}
//# sourceMappingURL=api.js.map